import { render } from "./ClientButton.vue?vue&type=template&id=bda56bb6"
import script from "./ClientButton.vue?vue&type=script&lang=js"
export * from "./ClientButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__